// extracted by mini-css-extract-plugin
export default {"errorCover":"errorCover___WlcI7","errorCover_message":"errorCover_message___wbHWe"};